// ShipmentField.jsx - مكون منفصل
import React, { memo } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ShipmentField = memo(({ 
  item, 
  index, 
  onRemove, 
  onInputChange, 
  shipmentCount,
  shipmentTypes 
}) => {
  const { t } = useTranslation();

  return (
    <div className="border p-3 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6>{t('shipment')} {index + 1}</h6>
        {shipmentCount > 1 && (
          <Button variant="outline-danger" size="sm" onClick={() => onRemove(index)}>
            <FaTrash />
          </Button>
        )}
      </div>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>{t('booking.quantity')}</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={item.quantity}
              onChange={(e) => onInputChange(index, 'quantity', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>{t('booking.type')}</Form.Label>
            <Form.Select
              value={item.shipment_data}
              onChange={(e) => onInputChange(index, 'shipment_data', e.target.value)}
            >
              {Object.keys(shipmentTypes).map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>{t('booking.weight')} (kg)</Form.Label>
            <Form.Control
              min={0}
              type="number"
              value={item.weight}
              onChange={(e) => onInputChange(index, 'weight', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>{t('booking.length')} (cm)</Form.Label>
            <Form.Control
              min={0}
              type="number"
              value={item.length}
              onChange={(e) => onInputChange(index, 'length', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>{t('booking.width')} (cm)</Form.Label>
            <Form.Control
              min={0}
              type="number"
              value={item.width}
              onChange={(e) => onInputChange(index, 'width', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>{t('booking.height')} (cm)</Form.Label>
            <Form.Control
              min={0}
              type="number"
              value={item.height}
              onChange={(e) => onInputChange(index, 'height', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
});

ShipmentField.displayName = 'ShipmentField';

export default ShipmentField;